import styled from 'styled-components/macro';
import { smallScreens } from '../../common/fontElements';

export const ResultRow = styled.tr`
  color: #000;
  cursor: pointer;
  border-bottom: 0.1rem solid #d8e8ef;
  display: flex;

  & em {
    background-color: #a1b6a7;
    color: #fff;
    font-style: normal;
  }

  & td {
    padding: 8px;
    line-height: 1.42857;
    vertical-align: top;
  }

  &:hover {
    color: #7f7f7f;
  }
`;
ResultRow.displayName = 'ResultRow';

export const ResultCancelSubscriptionRow = styled.tr`
  flex: 1;
  color: #ffffff;
  cursor: pointer;
  background-color: ${(props) => (props.active ? '#CCEBDE' : 'white')};
  display: flex;
  border-bottom: 0.1rem solid #d8e8ef;
  align-items: center;

  & em {
    background-color: #a1b6a7;
    color: #fff;
    font-style: normal;
  }

  & td {
    padding: 20px 8px 20px 8px !important;
    vertical-align: top;
    border-top: 0 !important;
    @media screen and (max-height: ${smallScreens}), screen and (max-width: ${smallScreens}) {
      padding: 10px 8px 10px 8px !important;
    }
  }

  &:hover {
    background-color: ${(props) => (props.active ? '#CCEBDE !important' : 'white !important')};
  }
`;
ResultCancelSubscriptionRow.displayName = 'ResultCancelSubscriptionRow';

export const ResultsCancelSubscriptionNameColumn = styled.td`
  color: #000;
  font-family: lato, sans-serif;
  font-weight: 400;
  line-height: 1.8rem;
  width: 100%;
  font-size: 12px;
  @media screen and (max-height: ${smallScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 10px;
  }
`;

export const ResultsNameColumn = styled.td`
  color: #000;
  font-family: lato, sans-serif;
  font-weight: 400;
  line-height: 1.8rem;
  width: 100%;

  &:hover {
    border-radius: 5px;
    color: #7f7f7f;
  }

  &:hover span {
    color: #7f7f7f;
  }
`;

export const ResultsStatusColumn = styled.td`
  color: #7f7f7f;
  font-family: lato, sans-serif;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.8rem;
  text-align: left;
  width: 10rem;

  &:hover {
    border-radius: 5px;
    color: #7f7f7f;
  }
`;

export const ResultsCancelSubscriptionStatusColumn = styled.td`
  color: ${(props) => (props.active ? '#72B987 !important' : '#7f7f7f')};
  font-family: lato, sans-serif;
  letter-spacing: 0.5px;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.8rem;
  text-align: left;
  width: 10rem;
`;

export const ResultsOrderNumber = styled.span`
  color: #08205e;
  font-family: lato, sans-serif;
  font-weight: 400;
`;
